import React from 'react';

function browserSupportsAllFeatures() {
    return typeof String.prototype.startsWith !== "undefined" && String.prototype.startsWith.toString().indexOf("[native code]") !== -1;
}

if (!browserSupportsAllFeatures()) {
  require("string.prototype.startswith");
}
export class Website extends React.Component {
    constructor(props){
        super(props);
    }

    render() {
        if(this.props.webaddress != null) 
        {
            let webaddress = this.props.webaddress.toLowerCase();
            let icon = null;

            if (webaddress.startsWith('http://') || webaddress.startsWith('https://')) {
                var res = webaddress.replace(/(http:\/\/|https:\/\/)/, "");
                if (this.props.icon) {
                    icon = <span className="icon-new-tab no-modal"> </span>;
                    return <a href={webaddress} target={this.props.target} title= {res} className={this.props.className}>{icon}</a>;
                }
            return <p><a href={webaddress} target={this.props.target} title={res} className={this.props.className}>{res}</a></p>;
            } 
            else {
                if (this.props.icon) {
                    icon = <span className="icon-new-tab no-modal"> </span>;
                    return <a href={"http://" + webaddress} target={this.props.target} title={webaddress} className={this.props.className}>{icon}</a>;
                }
                return <p><a href={"http://" + webaddress} target={this.props.target} title={webaddress} className={this.props.className}>{webaddress}</a></p>;
            }
        }
        else 
        {
            return <p></p>;
        }
        
        
    }
}

Website.defaultProps = {
    target: '_blank',
    className: 'website'
};